export default "__VITE_ASSET__iSiHWM5u__"